import React, { useState, useContext } from "react";

import {
  ContactPage,
  ContactScreen,
  ContactMainContainer,
  ContactLottieContainer,
  ContactDataContainer,
  ContactCard,
  SendButton,
  ContactLottie,
} from "./contact.styles.jsx";

//assets
import contactLottie from "../../assets/lotties/contactLottie2.json";
import darkContactLottie from "../../assets/lotties/contactLottie3.json";

import { ThemeContext } from "../../theme.context";

//libs
import { Fade, Flip } from "react-reveal";
import Lottie from "react-lottie";
import { TextField } from "@mui/material";

import { sendEmail } from "../../utils/email";

import StatusModal from "../../components/statusModal/statusModal.component.jsx";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const schema = yup
  .object({
    name: yup.string().required("Please enter your email"),
    email: yup
      .string()
      .email("Please enter a valid email.")
      .required("Please enter your email"),
    contact: yup
      .string()
      .matches(phoneRegExp, "Phone number is not valid")
      .min(10, "Phone number too short")
      .max(10, "Phone number too long"),
  })
  .required();

const Contact = () => {
  // const [data, setData] = useState({
  //   name: "",
  //   email: "",
  //   work: "",
  //   contact: "",
  // });
  const [showStatusModal, setShowStatusModal] = useState(false);

  const { darkMode } = useContext(ThemeContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  // const handleChange = (e) => {
  //   setData({ ...data, [e.target.name]: e.target.value });
  // };

  const toggleStatusModal = () => {
    setShowStatusModal(!showStatusModal);
  };

  const contactLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: darkMode ? darkContactLottie : contactLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const submitForm = async (data) => {
    console.log(data);
    const res = await sendEmail(data);

    toggleStatusModal();
  };

  return (
    <ContactPage dark={darkMode}>
      <div class="wave1">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
            fill={darkMode ? "#FF3B81" : "#3957D2"}
          ></path>
        </svg>
      </div>
      <StatusModal
        state={showStatusModal}
        // state={true}
        toggleModal={toggleStatusModal}
        status="success"
      />
      <ContactScreen id="contact-section" dark={darkMode}>
        <Fade left>
          <h1 className="page-title">LETS CONNECT !</h1>
        </Fade>
        <ContactMainContainer>
          <ContactLottieContainer>
            <Fade left delay={500}>
              <ContactLottie>
                <Lottie
                  options={contactLottieOptions}
                  width="100%"
                  height="100%"
                />
              </ContactLottie>
            </Fade>
          </ContactLottieContainer>

          <ContactDataContainer>
            <Flip right delay={1000}>
              <ContactCard dark={darkMode}>
                <div className="contact-header">CONTACT ME</div>
                <form onSubmit={handleSubmit(submitForm)}>
                  <TextField
                    label="Name"
                    variant="outlined"
                    name="name"
                    // onChange={handleChange}
                    fullWidth
                    {...register("name")}
                  />
                  <p className="error-message">{errors.name?.message}</p>
                  <TextField
                    label="Email"
                    variant="outlined"
                    name="email"
                    // onChange={handleChange}
                    fullWidth
                    {...register("email")}
                  />
                  <p className="error-message">{errors.email?.message}</p>

                  <TextField
                    label="Mobile No"
                    variant="outlined"
                    name="contact"
                    // onChange={handleChange}
                    fullWidth
                    {...register("contact")}
                  />
                  <p className="error-message">{errors.contact?.message}</p>
                  <TextField
                    label="Work"
                    variant="outlined"
                    name="work"
                    // onChange={handleChange}
                    fullWidth
                    rows={5}
                    multiline
                    {...register("work")}
                  />
                  <SendButton type="submit" dark={darkMode}>
                    SEND
                  </SendButton>
                </form>
              </ContactCard>
            </Flip>
          </ContactDataContainer>
        </ContactMainContainer>
        <div class="custom-shape-divider-bottom-1647097737">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
              class="shape-fill"
              fill={darkMode ? "#FF3B81" : "#3957D2"}
            ></path>
          </svg>
        </div>
      </ContactScreen>
    </ContactPage>
  );
};

export default Contact;
